import {
  AUTH_SET_SESSION,
  AUTH_LOGOUT,
  AUTH_UPDATE_USER,
  AUTH_SET_ONBOARDING,
} from "./actionTypes";

export const setSession = ({ accessToken, user }) => ({
  type: AUTH_SET_SESSION,
  payload: { accessToken, user },
});

export const updateUser = (user) => ({
  type: AUTH_UPDATE_USER,
  payload: user,
});

export const setOnboardingComplete = (status) => ({
  type: AUTH_SET_ONBOARDING,
  payload: status,
});

export const logout = () => ({
  type: AUTH_LOGOUT,
});
